import React, { useEffect, useState } from 'react';
import NewHeader from '../HomePage/NewHeader';
import GlobalStyle from '../../styles/globalStylesV2';
import NewFooter from '../HomePage/NewFooter';
import PageGrid from './PageGrid';
import { ColorPageTop, MainContainerWithAds } from './styled';
import ColorPageBreadCrumbs from './ColorPageBreadCrumbs';
import ColorPageFaqs from './ColorPageFaqs';
import { NextSeo } from 'next-seo';
import { isDesktopUser } from '../../Utils/ProductUtils';
import AdsBanner from '../ArticlePage/AdsBanner';
import { fireViewedColorPage } from './utils';
import { colorPageFootNote } from './constant';
import {
  androidDisablePullRefresh,
  checkAndroidStopLoader,
  enableAndroidBack,
  hideAndroidBottomBar,
  useAndroidShowTopBar,
} from '../../Utils/androidUtils';
import { isAndroidAppUser } from '../../Utils/helper';
import { iosHideTopBar, isIOSAppUser } from '../../Utils/IosUtils';
import { MainContainer } from '../Product/PdpHeader/styled';

const ColoringPagesMain = (props) => {
  const { categoryNavBarData } = props;
  const [addedToCart, setAddedToCart] = useState(null);
  const [hideHamIcon, setShowHamIcon] = useState(false);
  useEffect(() => {
    fireViewedColorPage();
    if (isAndroidAppUser()) {
      useAndroidShowTopBar();
      enableAndroidBack(true);
      hideAndroidBottomBar();
      androidDisablePullRefresh();
      checkAndroidStopLoader();
      setShowHamIcon(true);
    }
    if (isIOSAppUser()) {
      iosHideTopBar();
      setShowHamIcon(true);
    }
  }, []);
  return (
    <>
      <GlobalStyle />
      <NextSeo
        title="Free Coloring Pages for Kids | Printable Coloring Sheets "
        description="Keep your child engaged with free coloring pages for kids! From adorable Squishmallows to vibrant Rainbow Friends, princess Peach, Barbie, and Sonic the Hedgehog, our collection of free printable coloring pages has something for every child."
      />
      {!hideHamIcon ? (
        <NewHeader
          showOldSubHeader={true}
          categoryData={categoryNavBarData}
          addedToCart={addedToCart}
          showCart={true}
          showTrackOrder={true}
          setAddedToCart={setAddedToCart}
          nostrip={true}
        />
      ) : null}
      <MainContainer noPadding paddingTop="140px" fullWidth>
        <ColorPageTop>
          <div className="overlay">
            <h1>Free Coloring Pages for Kids | Printable Coloring Sheets</h1>

            <p>
              {`Explore our extensive collection of free coloring pages
                        for kids, featuring a delightful array of themes
                        including Squishmallow characters, Rainbow Friends,
                        Princess Peach, Barbie, and Sonic the Hedgehog. Let your
                        child's imagination soar as they bring these beloved
                        characters to life with vibrant colors. Download and
                        print these engaging coloring pages to provide hours of
                        creative entertainment for your little ones.
                        `}
            </p>
          </div>
        </ColorPageTop>
      </MainContainer>
      {!hideHamIcon && <ColorPageBreadCrumbs />}
      <MainContainerWithAds>
        <PageGrid hideHamIcon={hideHamIcon} />
        {isDesktopUser() && (
          <div className="adsContainer">
            <AdsBanner
              style={{
                display: 'inline-block',
                width: '300px',
                height: '600px',
              }}
              data-ad-slot="5758741792"
            />
            <br />
            <br />
            <AdsBanner
              style={{
                display: 'inline-block',
                width: '300px',
                height: '250px',
              }}
              data-ad-slot="4829088918"
            />
          </div>
        )}
      </MainContainerWithAds>

      <ColorPageFaqs />
      {!hideHamIcon && (
        <NewFooter altFooter={true} content={colorPageFootNote} />
      )}
    </>
  );
};

export default ColoringPagesMain;
